import {ValueDefinition} from '@/model/types';

export const enum Province {
  QUEBEC = 'DV-10#0',
  REST_OF_CANADA = 'DV-10#1',
}

export const DV_10 = {
  id: 'DV-10',
  description: {
    fr: 'Province',
    en: 'Province',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Québec',
        en: 'Québec',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Hors du Québec',
        en: 'Rest of Canada',
      },
    },
  ],
} as const satisfies ValueDefinition;
